<div class="container-fluid px-0 bg-star">
<div class="container py-5">
    <div class="row">
        <div class="col-md-8 col-lg-6 m-auto">
            <div class="signup-form">
                <h5 class="mb-4">Sign Up as a Choreographer</h5>
                <form [formGroup]="choreographerForm" (ngSubmit)="onSigup(choreographerForm)">
                    <div class="form-group">
                        <label for="emailInput" class="form-label">Your Email address</label>
                        <input type="email" class="form-control" formControlName="email" id="emailInput">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f2['email'].errors?.['required'] || f2['email'].errors?.['email']) && (f2['email'].dirty || f2['email'].touched)">
                            Please fill valid email.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Create Password:</label>
                        <input type="password" class="form-control" formControlName="password">
                        <div class="invalid-feedback d-block"
                            *ngIf="(f2['password'].errors?.['required'] || f2['password'].errors?.['minlength']) && (f2['password'].dirty || f2['password'].touched)">
                            Please fill 8 character long password.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Re-Enter Password:</label>
                        <input type="password" class="form-control" formControlName="re_password">
                        
                        <div *ngIf="f2['re_password'].touched && f2['re_password'].invalid" class="invalid-feedback d-block">
                            <div *ngIf="f2['re_password'].errors['confirmedValidator']">Password and Re-Enter Password must be match.</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">First Name:</label>
                        <input type="text" class="form-control" formControlName="first_name">
                        <div class="invalid-feedback d-block"
                            *ngIf="f2['first_name'].errors?.['required'] && (f2['first_name'].dirty || f2['first_name'].touched)">
                            Please fill first name.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Last Name:</label>
                        <input type="text" class="form-control" formControlName="last_name">
                        <div class="invalid-feedback d-block"
                            *ngIf="f2['last_name'].errors?.['required'] && (f2['last_name'].dirty || f2['last_name'].touched)">
                            Please fill last name.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="form-label">Date of Birth:</label>
                        <div class="input-group mb-3">
                            <input type="text" [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" formControlName="dob" form class="form-control" placeholder="DOB"
                                aria-label="DOB">
                            <div class="input-group-append d-flex" [owlDateTimeTrigger]="dt3">
                                <span class="input-group-text rounded-0"><i class="fa fa-calendar"></i></span>
                            </div>
                        </div>
                        <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                        <div class="invalid-feedback d-block"
                            *ngIf="f2['dob'].errors?.['required'] && (f2['dob'].dirty || f2['dob'].touched)">
                            Please select dob.
                        </div>
                        <div class="invalid-feedback d-block"
                            *ngIf="f2['dob'].errors?.['futureDate'] && (f2['dob'].dirty || f2['dob'].touched)">
                            Date of birth cannot be in the future.
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="sel1" class="form-label">Country:</label>
                        <select class="form-control" formControlName="country" id="sel1">
                            <option>Select</option>
                            <ng-container  *ngFor="let country of countries">
                                <option value="{{country.code}}">{{country.name}}</option>
                            </ng-container>
                        </select>
                        <div class="invalid-feedback d-block"
                            *ngIf="f2['country'].errors?.['required'] && (f2['country'].dirty || f2['country'].touched)">
                            Please select country.
                        </div>
                    </div>
                    <div class="form-group">
                        <input type="checkbox" formControlName="trial" [checked]="f2['trial'].value" value="1" name="trial" id="trial">
                        <label for="trial" class="d-inline-block ms-2 form-label">Activate Trial</label>
                    </div>
                    <div class="row" *ngIf="plans && f2['trial'].value!=1">
                        <label for="" class="form-label">Purchase Plan</label>
                        <div class="col-md-6 mb-2" *ngFor="let plan of plans">
                            <div class="plan-box">
                                <div class="heading mb-3">
                                    {{plan.title}}
                                </div>
                                <!-- <div class="sub-heading mb-3">
                                    [NOVICE - MEDIAN]
                                </div> -->
                                    <div class="input-radios-wrap">
                                        <div>
                                            <input type="radio" formControlName="plan" value="{{plan.stripe_plan_id}}" name="plan" id="plan{{plan.stripe_plan_id}}">
                                            <label for="plan{{plan.stripe_plan_id}}">{{plan.period}} ({{plan.price}} USD*)</label>
                                        </div>
                                    </div>
                            </div>
                        </div>
                        
                    </div>
                    <div class="invalid-feedback d-block"
                        *ngIf="f2['plan'].errors?.['required'] && (f2['plan'].dirty || f2['plan'].touched)">
                        Please select plan.
                    </div>
                    <div class="d-flex justify-content-end mt-3">
                        <button type="submit" class="btn btn-gold mt-2 ml-auto">Sign Up <i *ngIf="formSubmitting" class="fa fa-spinner fa-spin"></i></button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</div>
